<form class="region-filter-modal-molecule-root" *transloco="let t">
  <div class="title">
    <app-label isGray class="label">{{ t('region-filter') }}</app-label>
    <button id="close-filter-date-icon" (click)="onCloseClick()" mat-icon-button class="close-button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <app-label isGray>{{ t('select-subregions') }}</app-label>
  <ng-container *ngFor="let region of availableRegions">
    <app-checkbox [id]="region.id"
                  [formGroup]="form"
                  [abstractFormControlName]="region.id.toString()">
                  {{region.name}}
    </app-checkbox>
  </ng-container>
  <div mat-dialog-actions>
    <app-primary-button class="success-button"
                        id="submit-btn"
                        mat-button
                        type="submit"
                        (clickAction)="submit()">
      {{ t('filter-regions') }}
    </app-primary-button>
    <app-primary-button id="cancel-btn"
                        mat-button
                        (clickAction)="cancel()">
      {{ t('cancel') }}
    </app-primary-button>
  </div>
</form>
